const Logs = () => (
  <>
    <p className="console-panel-desc">查看 API 调用历史、状态码与耗时等详细信息。</p>
    <div className="console-card">
      <div className="console-card-body">
        <div className="console-empty">
          <span className="console-empty-icon">📄</span>
          <p>暂无调用记录</p>
          <p style={{ fontSize: '0.8125rem' }}>发起 API 请求后，日志将自动出现在此处</p>
        </div>
      </div>
    </div>
  </>
);

export default Logs;
